(function () {
  var root = document.querySelector("[data-mad-stories]");
  if (!root) return;

  var tabs = root.querySelectorAll("[data-tab]");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) {
        t.classList.toggle("is-active", t === tab);
        t.setAttribute("aria-selected", t === tab ? "true" : "false");
      });
      root.classList.remove("is-surf", "is-sports");
      if (tab.getAttribute("data-tab") === "surf") root.classList.add("is-surf");
      if (tab.getAttribute("data-tab") === "sports") root.classList.add("is-sports");
    });
  });

  var form = root.querySelector("[data-mad-form]");
  if (!form) return;
  var status = form.querySelector("[data-form-status]");
  var cfg = window.MAD_STORIES || {};

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    status.hidden = false;
    status.className = "mad-stories__form-status";

    if (!cfg.endpoint) {
      status.textContent = "Submit endpoint is not configured yet. Stories are not going live automatically.";
      status.classList.add("is-err");
      return;
    }

    var data = Object.fromEntries(new FormData(form).entries());
    if (data.honeypot) return;
    if (!data.permission) {
      status.textContent = "Permission is required.";
      status.classList.add("is-err");
      return;
    }

    try {
      var res = await fetch(cfg.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Mad-Key": cfg.secret || ""
        },
        body: JSON.stringify(data)
      });
      var json = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(json.error || "Could not send story");
      form.reset();
      status.textContent = "Got it. Your story is in the review queue and will not go live until MAD! approves it.";
      status.classList.add("is-ok");
    } catch (err) {
      status.textContent = err.message || "Something went wrong.";
      status.classList.add("is-err");
    }
  });
    root.querySelectorAll("[data-copy]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var url = btn.getAttribute("data-copy");
      if (navigator.clipboard && url) {
        navigator.clipboard.writeText(url).then(function () {
          btn.textContent = "Copied";
          setTimeout(function () { btn.textContent = "Copy link"; }, 1600);
        });
      }
    });
  });
})();